import { useEffect } from 'react';

/** Clase CSS que bloquea el scroll de un elemento */
const LOCK_SCROLL_CLASS = 'scrollLocked';

/**
 * Hook que bloquea el scroll del body y opcionalmente de elementos adicionales.
 * Agrega la clase 'scrollLocked' a los elementos para bloquear el scroll.
 * Restaura el scroll automáticamente cuando el componente se desmonta o cuando isLocked cambia a false.
 * @param isLocked - Indica si el scroll debe estar bloqueado
 * @param additionalElementIds - Array opcional de IDs de elementos adicionales a los que bloquear el scroll
 */
const useLockScroll = (isLocked: boolean, additionalElementIds?: string[]): void => {
  useEffect(() => {
    if (!isLocked) return;

    // Bloquear scroll del body
    document.body.classList.add(LOCK_SCROLL_CLASS);

    // Bloquear scroll de elementos adicionales
    const lockedElements: HTMLElement[] = [];

    if (additionalElementIds?.length) {
      additionalElementIds.forEach(id => {
        const element = document.getElementById(id);
        if (element) {
          element.classList.add(LOCK_SCROLL_CLASS);
          lockedElements.push(element);
        }
      });
    }

    // Restaurar scroll al desmontar o cuando isLocked cambie a false
    return () => {
      document.body.classList.remove(LOCK_SCROLL_CLASS);

      lockedElements.forEach(element => {
        element.classList.remove(LOCK_SCROLL_CLASS);
      });
    };
  }, [isLocked, additionalElementIds]);
};

export default useLockScroll;

